import { getTextDirection } from "./i18n/direction.js";
//#region src/i18n/index.ts
/** Default locale used when no player or ambient locale is available. */
const DEFAULT_LOCALE = "en";
/** Whether the first locale in a lookup list is the default locale or one of its regional variants. */
function isDefaultLocale(locale) {
	const tag = Array.isArray(locale) ? locale[0] : locale;
	if (!tag) return true;
	return tag === "en" || tag.startsWith(`en-`);
}
//#endregion
export { DEFAULT_LOCALE, getTextDirection, isDefaultLocale };

//# sourceMappingURL=i18n.js.map